import FontFaceObserver from 'fontfaceobserver';
import { constVoid } from 'fp-ts/function';
import { getIconsetCSS, MEWS_ICONS_FONT_FAMILY } from '@mews/framework';

const loadFont = async (fontName: string, success = constVoid, error = constVoid) => {
    const font = new FontFaceObserver(fontName);

    return font.load().then(success).catch(error);
};

const injectFontFace = () => {
    const styleContent = getIconsetCSS();
    const styleElement = document.createElement('style');

    styleElement.textContent = styleContent;
    document.head.appendChild(styleElement);
};

export const loadIconFont = async () => {
    injectFontFace();

    return loadFont(MEWS_ICONS_FONT_FAMILY, () => {
        document.body.className += ` mews-icons-loaded`;
    });
};
